module.exports = __webpack_public_path__ + "img/registration-success.f41a1be8.svg";